export var PRODUCT_GRID_IMAGE_BREAKPOINTS = "(min-width: 1571px) 360px, (min-width: 1440px) 240px, (min-width: 1324px) 360px, (min-width: 768px) 240px,(min-width: 519px) 360px, (min-width: 399px) 240px, 180px";
